module.exports = __webpack_public_path__ + "static/img/skyline-right.433ca88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/skyline-right.png
// module id = 684
// module chunks = 64